<template>
  <v-container class="ma-0 pa-0 pb-8">
    <div class="pt-6 px-8 pb-6">
      <v-row class="ma-0 mb-2">
        <strong>Filtros</strong>
        <v-spacer></v-spacer>
        <v-btn @click="clearFilters" small class="elevation-0" style="border:solid 1px #dddddd;">
          <v-icon small class="mr-1">mdi-filter-off</v-icon> Limpiar
        </v-btn>
      </v-row>

      <v-menu offset-y :close-on-content-click="false" v-model="menuDate">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            clearable
            v-model="dateText"
            label="Rango de fechas"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker v-model="filters.dateRange" range />
      </v-menu>

      <v-autocomplete
        v-model="filters.provider_id"
        :items="providerLists"
        hide-no-data
        item-value="id"
        item-text="name"
        label="Proveedor(es)"
        placeholder="Escribe para buscar"
        attach
        chips
        multiple
      />

      <v-text-field label="Factura de Compra" v-model="filters.shopping_invoice"></v-text-field>

      <v-text-field label="ID de Compra" v-model="filters.shopping_id"></v-text-field>

      <v-autocomplete
        v-model="filters.payment_method"
        :items="methodLists"
        hide-no-data
        item-value="id"
        item-text="method"
        label="Método(s) de pago"
        placeholder="Escribe para buscar"
        attach
        chips
        multiple
      />

      <v-text-field
        v-model="filters.note"
        label="Referencia"
      />
    </div>

    <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
      <v-list-item link @click="applyFilters" dark>
        <v-list-item-content>
          <strong>Filtrar ({{ activeFiltersCount }})</strong>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    filters: {
      dateRange: [],
      provider_id: [],
      payment_method: [],
      note: "",
      shopping_invoice: "",
      shopping_id: "",
    },
    menuDate: false,
  }),
  computed: {
    providerLists() {
      return this.$store.state.provider.providers;
    },
    methodLists() {
      return this.$store.state.payment_method.payment_methods;
    },
    activeFiltersCount() {
      let c = 0;
      if (this.filters.dateRange?.length) c++;
      if (this.filters.provider_id?.length) c++;
      if (this.filters.payment_method?.length) c++;
      if (this.filters.note?.trim()) c++;
      if (this.filters.shopping_invoice?.trim()) c++;
      if (this.filters.shopping_id?.trim()) c++;
      return c;
    },
    dateText() {
      if (!this.filters.dateRange?.length) return "";
      return `${this.filters.dateRange[0]} - ${this.filters.dateRange[1]}`;
    },
  },
  created() {
    const saved = localStorage.getItem("providerPaymentFilters");
    if (saved) {
      this.filters = JSON.parse(saved);
      // Emitirlos inmediatamente para que la tabla los use
      this.emitFilters();
    }
  },
  methods: {
    applyFilters() {
      localStorage.setItem("providerPaymentFilters", JSON.stringify(this.filters));
      this.emitFilters();
    },
    clearFilters() {
      this.filters = {
        dateRange: [],
        provider_id: [],
        payment_method: [],
        note: "",
        shopping_invoice:"",
        shopping_id:"",
      };
      localStorage.removeItem("providerPaymentFilters");
      this.emitFilters();
    },
    emitFilters() {
      const params = {};
      if (this.filters.note) params["filter[note]"] = this.filters.note;
      if (this.filters.shopping_invoice) params["filter[shoppings.invoice]"] = this.filters.shopping_invoice;
      if (this.filters.shopping_id) params["filter[shoppings.id]"] = this.filters.shopping_id;
      if (this.filters.provider_id.length) params["filter[provider_id]"] = this.filters.provider_id.join(",");
      if (this.filters.payment_method.length) params["filter[payment_method]"] = this.filters.payment_method.join(",");
      if (this.filters.dateRange.length === 2)
        params["filter[date]"] = `${this.filters.dateRange[0]},${this.filters.dateRange[1]}`;

      this.$emit("filters", params, this.activeFiltersCount);
    },
  },
};
</script>
